var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnOutlink = function SvgIcnOutlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.333 5.333c0-.368.299-.666.667-.666h4.667c.368 0 .666.298.666.666V10A.667.667 0 0 1 10 10V6.943l-4.195 4.195a.667.667 0 1 1-.943-.943L9.057 6H6a.667.667 0 0 1-.667-.667",
    clipRule: "evenodd"
  })));
};
export { SvgIcnOutlink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMzMzIDUuMzMzYzAtLjM2OC4yOTktLjY2Ni42NjctLjY2Nmg0LjY2N2MuMzY4IDAgLjY2Ni4yOTguNjY2LjY2NlYxMEEuNjY3LjY2NyAwIDAgMSAxMCAxMFY2Ljk0M2wtNC4xOTUgNC4xOTVhLjY2Ny42NjcgMCAxIDEtLjk0My0uOTQzTDkuMDU3IDZINmEuNjY3LjY2NyAwIDAgMS0uNjY3LS42NjciIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";